import { useOne, useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { theme } from 'antd';
import type {
  PublicationListOut,
  SessionDetailOut,
} from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import { SESSION_DEFAULT_TAB, SESSION_SHOW_TABS } from '../constants';
import { SessionShowHeader } from './SessionShowHeader';
import { SessionGeneralTab } from './SessionGeneralTab';

export const SessionShow = () => {
  const { token } = theme.useToken();
  const { query } = useShow<SessionDetailOut>({
    resource: 'progress.sessions',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  const { result: publication } = useOne<PublicationListOut>({
    resource: 'user_catalog.publications',
    id: record?.publication_id ?? 0,
    queryOptions: { enabled: !!record?.publication_id },
  });

  useRecordDocumentTitle(
    'progress.sessions',
    record && (publication?.title ?? `#${record.id}`)
  );

  const [activeTab, onTabChange] = useShowTab(
    SESSION_SHOW_TABS,
    SESSION_DEFAULT_TAB
  );

  return (
    <Show isLoading={isLoading} contentProps={bareShowContentProps}>
      {record && (
        <>
          <SessionShowHeader
            record={record}
            publication={publication}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <div style={{ marginTop: token.margin }}>
            {activeTab === 'general' && (
              <SessionGeneralTab record={record} publication={publication} />
            )}
          </div>
        </>
      )}
    </Show>
  );
};
